import api from './api';

/**
 * Servicio para gestionar inventario
 */
export const inventarioService = {
  /**
   * Obtener inventario por sucursal
   * @param {number} sucursalId - ID de la sucursal
   * @param {boolean} soloStockBajo - Filtrar solo productos con stock bajo (opcional)
   */
  getBySucursal: async (sucursalId, soloStockBajo = null) => {
    const params = {};
    if (soloStockBajo !== null) params.soloStockBajo = soloStockBajo;
    const response = await api.get(`/inventario/sucursal/${sucursalId}`, { params });
    return response;
  },

  /**
   * Obtener stock de un producto específico en una sucursal
   * @param {number} productoId - ID del producto
   * @param {number} sucursalId - ID de la sucursal
   */
  getStock: async (productoId, sucursalId) => {
    const response = await api.get(`/inventario/producto/${productoId}/sucursal/${sucursalId}`);
    return response;
  },

  /**
   * Obtener productos con stock bajo
   * @param {number} sucursalId - ID de la sucursal (opcional)
   */
  getStockBajo: async (sucursalId = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    const response = await api.get('/inventario/stock-bajo', { params });
    return response;
  },

  /**
   * Obtener historial de movimientos
   * @param {number} sucursalId - ID de la sucursal (opcional)
   * @param {number} productoId - ID del producto (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   * @param {number} tipoMovimientoId - ID del tipo de movimiento (opcional)
   */
  getMovimientos: async (sucursalId = null, productoId = null, fechaDesde = null, fechaHasta = null, tipoMovimientoId = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    if (productoId) params.productoId = productoId;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    if (tipoMovimientoId) params.tipoMovimientoId = tipoMovimientoId;
    const response = await api.get('/inventario/movimientos', { params });
    return response;
  },

  /**
   * Registrar un movimiento de inventario
   * @param {object} movimiento - Datos del movimiento
   */
  registrarMovimiento: async (movimiento) => {
    const response = await api.post('/inventario/movimientos', movimiento);
    return response;
  },

  /**
   * Registrar una transferencia entre sucursales
   * @param {object} transferencia - Datos de la transferencia
   */
  registrarTransferencia: async (transferencia) => {
    const response = await api.post('/inventario/transferencias', transferencia);
    return response;
  },

  /**
   * Registrar un conteo físico
   * @param {object} conteo - Datos del conteo físico
   */
  registrarConteoFisico: async (conteo) => {
    const response = await api.post('/inventario/conteos-fisicos', conteo);
    return response;
  },

  /**
   * Obtener historial de conteos físicos
   * @param {number} sucursalId - ID de la sucursal (opcional)
   * @param {number} productoId - ID del producto (opcional)
   * @param {string} fechaDesde - Fecha desde (opcional)
   * @param {string} fechaHasta - Fecha hasta (opcional)
   */
  getConteosFisicos: async (sucursalId = null, productoId = null, fechaDesde = null, fechaHasta = null) => {
    const params = {};
    if (sucursalId) params.sucursalId = sucursalId;
    if (productoId) params.productoId = productoId;
    if (fechaDesde) params.fechaDesde = fechaDesde;
    if (fechaHasta) params.fechaHasta = fechaHasta;
    const response = await api.get('/inventario/conteos-fisicos', { params });
    return response;
  },

  /**
   * Actualizar stock mínimo de un producto en inventario
   * @param {number} inventarioId - ID del inventario
   * @param {number} stockMinimo - Nuevo stock mínimo
   */
  updateStockMinimo: async (inventarioId, stockMinimo) => {
    const response = await api.put(`/inventario/${inventarioId}/stock-minimo`, {
      StockMinimo: stockMinimo,
    });
    return response;
  },
};

